import { useState } from "react";
import { HeartPulse } from "lucide-react";
import { orbStore } from "@/lib/orb";
import { unlockAudio } from "@/lib/audio";

export const HeartToggle = ({ className = "" }) => {
  const [on, setOn] = useState(orbStore.heart);
  const toggle = () => {
    unlockAudio();
    orbStore.heart = !orbStore.heart;
    setOn(orbStore.heart);
  };
  return (
    <button onClick={toggle} data-testid="btn-heartbeat-sound"
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[11px] font-mono uppercase tracking-wider border transition-colors duration-200 ${on ? "border-rose-400/60 text-rose-200 bg-rose-500/10" : "border-slate-600 text-slate-400 hover:text-white"} ${className}`}>
      <HeartPulse size={13} className={on ? "pulse-dot" : ""} /> {on ? "Battito attivo" : "Senti il battito"}
    </button>
  );
};
